import React from "react";
import { useTranslation } from "react-i18next";

export const Screen: React.FC<{
  testId: string;
  wide?: boolean;
  offline?: boolean;
  children: React.ReactNode;
}> = ({ testId, wide, offline, children }) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex flex-col gap-[15px] font-['Open_Sans',sans-serif] ${wide ? "w-[360px]" : "w-[300px]"}`}
      data-testid={testId}
    >
      {children}
      {offline && (
        <div role="note" className="text-xs text-subtle">
          {t("Password login needs an internet connection.")}
        </div>
      )}
    </div>
  );
};

export const ScreenTitle: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div className="text-xl text-subtle">{children}</div>;

export const ScreenBody: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div className="text-xs leading-normal text-dark">{children}</div>;

export const LinkRow: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <div className="flex items-center justify-between">{children}</div>;
